import React, { useEffect, useRef, useState } from "react";
import { CheckCircle2, Clock, Loader2, XCircle, ExternalLink } from "lucide-react";
import { api } from "../lib/api";

const LABEL = { PAID: "Pembayaran berhasil", PENDING: "Menunggu pembayaran", EXPIRED: "Pembayaran kedaluwarsa", FAILED: "Pembayaran gagal" };

// Banner on /wallet?payment=INVOICE: polls the invoice until DOKU confirms it (max ~3 minutes).
export function DokuPaymentStatus({ invoice, onPaid, onClose }) {
  const [p, setP] = useState(null);
  const [polling, setPolling] = useState(true);
  const tries = useRef(0);
  useEffect(() => {
    let alive = true, timer;
    const tick = async () => {
      try {
        const r = await api.get(`/wallet/doku/payments/${invoice}`);
        if (!alive) return;
        setP(r.data);
        if (r.data.status === "PAID") { setPolling(false); onPaid?.(r.data); return; }
        if (r.data.status === "EXPIRED") { setPolling(false); return; }
      } catch { if (alive) setP((x) => x || { status: "NOT_FOUND" }); }
      if (++tries.current >= 45) { setPolling(false); return; }
      timer = setTimeout(tick, 4000);
    };
    tick();
    return () => { alive = false; clearTimeout(timer); };
    // eslint-disable-next-line
  }, [invoice]);
  const st = p?.status;
  const tone = st === "PAID" ? "border-emerald-200 bg-emerald-50" : st === "EXPIRED" || st === "FAILED" || st === "NOT_FOUND" ? "border-rose-200 bg-rose-50" : "border-amber-200 bg-amber-50";
  const Icon = st === "PAID" ? CheckCircle2 : st === "EXPIRED" || st === "FAILED" || st === "NOT_FOUND" ? XCircle : polling ? Loader2 : Clock;
  return (
    <div className={`mt-5 flex flex-wrap items-start gap-3 rounded-2xl border p-4 ${tone}`} data-testid="doku-payment-status">
      <Icon size={20} className={`mt-0.5 shrink-0 ${st === "PAID" ? "text-emerald-600" : st === "PENDING" || !st ? "text-amber-600" : "text-rose-600"} ${polling && st !== "PAID" ? "animate-spin" : ""}`} />
      <div className="min-w-0 flex-1 text-sm">
        <p className="font-bold text-slate-900" data-testid="doku-payment-status-label">{st === "NOT_FOUND" ? "Pembayaran tidak ditemukan" : LABEL[st] || "Memeriksa pembayaran…"}</p>
        <p className="mt-0.5 text-slate-600">
          No. invoice <span className="font-mono text-xs">{invoice}</span>
          {p?.amount ? <> · Rp {Number(p.amount).toLocaleString("id-ID")} · {Number(p.credits).toLocaleString("id-ID")} kredit</> : null}
        </p>
        {st === "PENDING" && <p className="mt-1 text-xs text-slate-500">{polling ? "Kami memeriksa status otomatis. Saldo bertambah begitu DOKU mengonfirmasi pembayaran." : "Belum ada konfirmasi. Jika Anda sudah membayar, saldo akan masuk otomatis begitu DOKU mengonfirmasi."}</p>}
        {st === "PAID" && <p className="mt-1 text-xs text-emerald-700">Kredit sudah ditambahkan ke saldo Anda. Struk pembayaran dikirim ke email Anda.</p>}
      </div>
      <div className="flex items-center gap-2">
        {st === "PENDING" && p?.payment_url && <a href={p.payment_url} className="flex items-center gap-1 rounded-xl bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 shadow-sm hover:bg-slate-50" data-testid="doku-payment-continue">Lanjutkan pembayaran <ExternalLink size={12} /></a>}
        <button onClick={onClose} className="rounded-xl px-3 py-1.5 text-xs font-semibold text-slate-500 hover:text-slate-800" data-testid="doku-payment-close">Tutup</button>
      </div>
    </div>
  );
}
